exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.full-height[data-v-1bd705fa] {\n  min-height: 77vh;\n}\n.search-icon-align[data-v-1bd705fa] {\n  position: relative;\n  left: 4px;\n  top: 1px;\n}\n.pointer[data-v-1bd705fa] {\n  cursor: pointer;\n}\n.vh-65[data-v-1bd705fa] {\n  height: 65vh;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-1bd705fa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/revenue/rules/TabRules.vue
// module id = 3084
// module chunks = 0